import { render, staticRenderFns } from "./courseYqjxsq.vue?vue&type=template&id=2cdf4052&scoped=true&"
import script from "./courseYqjxsq.vue?vue&type=script&lang=js&"
export * from "./courseYqjxsq.vue?vue&type=script&lang=js&"
import style0 from "./courseYqjxsq.vue?vue&type=style&index=0&id=2cdf4052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf4052",
  null
  
)

export default component.exports